import React from 'react';
import Select, { components } from 'react-select';
import { SvgIcon } from '@make-software/cspr-design';
import { AppsFiltersStyles, DropdownStyles } from 'app/components/common/common-styles';
import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { MarketplaceSortBy } from 'app/console-api/marketplace/marketplace';
import SortControlIcon from 'assets/icons/ic-sort-control.svg';

export const SortByAdapter: FilterAdapter<MarketplaceSortBy> = {
  key: 'sortBy',
  fromUrl: (sp) => {
    const v = sp.get('sortBy');
    return v === 'active_offers' || v === 'last_updated' ? v : 'last_updated';
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value) {
      next.delete('sortBy');
    } else {
      next.set('sortBy', value);
    }
    return next;
  },
  toKey: (v) => `sortBy:${v ?? 'default'}`
};

const SORT_OPTIONS: { value: MarketplaceSortBy; label: string }[] = [
  { value: 'active_offers', label: 'Most offers' },
  { value: 'last_updated', label: 'Recently updated' }
];

const SortIndicator = (props: any) => (
  <components.DropdownIndicator {...props}>
    <SvgIcon src={SortControlIcon} size={16} />
  </components.DropdownIndicator>
);

export const MarketplaceSortFilter = () => {
  const ctl = useUrlFilterController();
  const current = ctl.get(SortByAdapter);
  const value = SORT_OPTIONS.find((o) => o.value === current) ?? SORT_OPTIONS[0];

  return (
    <Select
      styles={DropdownStyles({menuPosition: "absolute", controlMinWidth: "180px"})}
      options={SORT_OPTIONS}
      value={value}
      isSearchable={false}
      components={{ DropdownIndicator: SortIndicator, IndicatorSeparator: null }}
      onChange={(opt) => ctl.set(SortByAdapter, opt?.value ?? null)}
    />
  );
};
